var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v(_vm._s(_vm.headerText))]),_c('Form'),_c('TotalBalance'),_c('BudgetList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }